import React, { useState } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createNotificationObject } from "../../Notification/Index";
import { getYearRange } from "../FinancialYearList/Helper/Script";
import { ExtractAddSlice } from "../ExtractAdd";
import { IRootState } from "../../../reducer/CombineReducer";
import ExtractAddDialogView from "./ExtractAddDialog.view";
import { ExtractModes } from "./redux/Types";
import { initialExtract } from "./redux/Slice";

interface ExtractAddDialogProps {
  /**
   * Flag to show the create extract action with / without label
   */
  isIconOnly: boolean;
}

/**
 * Responsible for rending Create extract components
 */
const ExtractAddDialog = (props: ExtractAddDialogProps): JSX.Element => {

  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [
    extractAdd,
    yearsState
  ] = useSelector((state: IRootState) => [
    state.extractAdd,
    state.yearsState,
  ], shallowEqual);
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const yearData = getYearRange();
  const notification = createNotificationObject(
    "create-extract",
    `${translate("Notification.CreateExtractSuccess")}`,
    "success");

  /**
   * Callback to toggle Extract Add dialog
   * returns
   */
  const toggleCreateDialog = (): void => {
    dispatch(ExtractAddSlice.actions.setExtractMode(ExtractModes.CREATE));
    dispatch(ExtractAddSlice.actions.setNewExtract(initialExtract));
    setShowDialog(!showDialog);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { extractGuid, ...rest } = extractAdd.newExtract;
    dispatch(ExtractAddSlice.actions.setNewExtract({
      ...rest,
      ["title"]: {
        "value": "",
        "valid": false,
        "errorText": ""
      },
      ["survey"]: {
        "value": "",
        "valid": false,
        "errorText": ""
      },
      ["schema"]: {
        "value": "",
        "valid": false,
        "errorText": ""
      },
      description: "",
      financialYear: yearsState.selectedYear
    }));
  };

  return (
    <ExtractAddDialogView
      show={showDialog}
      onClose={toggleCreateDialog}
      yearsDataValue={yearData}
      notification={notification}
      isIconOnly={props.isIconOnly}
    />
  );
};

export default ExtractAddDialog;
